export default __webpack_public_path__ + "static/media/aluno-recorte.aa1821ab.webp";